module.exports = __webpack_public_path__ + "df56111611d6af24484c297f471e47b6.pdf";